var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "12 13.5 26 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Add-to-project-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Jobs",
    className: "svg-path1",
    d: "M10.5263158,0 C12.1381579,0 13.4539474,1.13333333 13.75,2.66666667 L13.75,2.66666667 L21.0526316,2.66666667 L21.0526316,20 L-3.83693077e-13,20 L-3.83693077e-13,2.66666667 L7.30263158,2.66666667 C7.59868421,1.13333333 8.91447368,0 10.5263158,0 Z M19.7368421,13.8333333 L1.31578947,13.8333333 L1.31578947,18.6666667 L19.7368421,18.6666667 L19.7368421,13.8333333 Z M19.7368421,4 L1.31578947,4 L1.31578947,12.5 L19.7368421,12.5 L19.7368421,4 Z M10.5263158,9.53333333 C11.0168319,9.53333333 11.4144737,9.93627706 11.4144737,10.4333333 C11.4144737,10.9303896 11.0168319,11.3333333 10.5263158,11.3333333 C10.0357997,11.3333333 9.63815789,10.9303896 9.63815789,10.4333333 C9.63815789,9.93627706 10.0357997,9.53333333 10.5263158,9.53333333 Z M10.5263158,1.33333333 C9.63815789,1.33333333 8.91447368,1.9 8.65131579,2.66666667 L8.65131579,2.66666667 L12.4013158,2.66666667 C12.1381579,1.86666667 11.4144737,1.33333333 10.5263158,1.33333333 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(14.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M6,0 C2.69169231,0 0,2.69169231 0,6 C0,9.30830769 2.69169231,12 6,12 C9.30830769,12 12,9.30830769 12,6 C12,2.69169231 9.30830769,0 6,0 Z M6.07692308,1 C8.88630769,1 11.1538462,3.26753846 11.1538462,6.07692308 C11.1538462,8.88630769 8.88630769,11.1538462 6.07692308,11.1538462 C3.26753846,11.1538462 1,8.88630769 1,6.07692308 C1,3.26753846 3.26753846,1 6.07692308,1 Z M5.72727273,3 L5.72727273,5.72727273 L3,5.72727273 L3,6.81818182 L5.72727273,6.81818182 L5.72727273,9.54545455 L6.81818182,9.54545455 L6.81818182,6.81818182 L9.54545455,6.81818182 L9.54545455,5.72727273 L6.81818182,5.72727273 L6.81818182,3 L5.72727273,3 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTo);
export default __webpack_public_path__ + "static/media/add-to.fae8ab0a5757a68fb22c84e916ac9e2a.svg";
export { ForwardRef as ReactComponent };